module.exports = __webpack_public_path__ + "img/icon-24-ic-add-white.122f76fe.svg";